import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './agent-booking-video-inprocess.component.ajs.html';

const MODULE_NAME = 'agentBookingVideoInprocess';

class AgentBookingVideoInprocessCtrl implements IComponentController {
  public name = MODULE_NAME;

  responseId: string;

  $onInit() {}
}

export class AgentBookingVideoInprocess implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  } as { [binding: string]: string };
  controller = [AgentBookingVideoInprocessCtrl];
}

export default MODULE_NAME;
